import React from "react";
import { CircularProgress } from "@mui/material";

const LoadingSpinner = () => {
  return <CircularProgress />;
};

export default LoadingSpinner;
